// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1zd0K","label":"Completed_label__1m_KS"};